import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=0b7c5c31&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7c5c31')) {
      api.createRecord('0b7c5c31', component.options)
    } else {
      api.reload('0b7c5c31', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=0b7c5c31&", function () {
      api.rerender('0b7c5c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Controls/Checkbox.vue"
export default component.exports